import UserIcon from '@assets/CustomIcons/user_edited.svg'
import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { formatters } from '@utils/intl/dateTimeFormatters'
import type { ICellRendererParams } from 'ag-grid-community'
import { Col, Popover, Row } from 'antd'
import moment from 'moment'

const iconStyles = {
  width: 24,
  height: 24,
}

type BaseUserFields = {
  updated_on: string
  updated_by?: string
}

export function ShortUpdatedRenderer<T extends BaseUserFields>({ data }: Partial<ICellRendererParams<T>>) {
  return (
    <Popover
      content={
        <Horizontal verticalCenter>
          <Vertical flex={2}>
            <Texto category='label' weight='600'>
              Last Updated By
            </Texto>
            <Horizontal className='popover-icon' verticalCenter>
              <img src={UserIcon} style={iconStyles} />
              <p className='popover-status-text pl-2'>{data?.updated_by ?? 'Gravitate'}</p>
            </Horizontal>
          </Vertical>
          <Vertical flex={1.5}>
            <Texto category='label' weight='600'>
              At
            </Texto>
            <Texto category='p1' className='popover-city-text'>
              {formatters.WEEKDAY_MONTH_DATE_TIME(moment(data?.updated_on || data?.updated_date))}
            </Texto>
          </Vertical>
        </Horizontal>
      }
      trigger='hover'
    >
      <Row className='order-stat-tag-container' style={{ flexWrap: 'nowrap' }}>
        <Col className='vertical-flex-center'>
          <img src={UserIcon} style={iconStyles} />
        </Col>
        <Col flex={1} className='p-2 pr-3 vertical-flex-center h-100'>
          <Texto style={{ fontWeight: 'bold', flexWrap: 'nowrap' }}>
            {formatters.SHORT_DATE_TIME(moment(data?.updated_on || data?.updated_date))}
          </Texto>
        </Col>
      </Row>
    </Popover>
  )
}
